import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const RestaurantModal = ({ show, setShow, data, onSelect }) => {
  return (
    <div className="container mt-5">
      {show && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ zIndex: 1050 }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Restaurants</h5>
                <button
                  type="button"
                  className="close btn btn-danger"
                  onClick={() => setShow(false)}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <p className="text-center">
                  {data.length === 0 && "No Restaurents Found of Resy "}
                </p>
                <div className="row">
                  {data?.map((restaurant, index) => (
                    <div
                      key={index}
                      className="col-lg-4 col-md-6 col-sm-12 mb-3"
                    >
                      <div className="card h-100">
                        <div className="text-center">
                          <img
                            src={
                              restaurant.images ??
                              `https://fakeimg.pl/350x200/?text=No Image`
                            }
                            className="card-img-top img-fluid"
                            alt={restaurant.name}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div className="card-body">
                          <h5 className="card-title">{restaurant.name}</h5>
                          <p className="card-text">
                            Location: {restaurant.location}
                          </p>
                          <div
                            onClick={() => onSelect(restaurant)}
                            className="btn btn-primary"
                          >
                            Select
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RestaurantModal;
